import { render, staticRenderFns } from "./App.vue?vue&type=template&id=86e96ffc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=86e96ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports